import React from "react";
import "./index.scss";
import {number} from "prop-types";
import {__} from "services/i18n";
import Text from "features/components/text";
import {Icon} from "features/components/icon";

const OnboardingStages = (props) => {
    const {index} = props;
    return <div className={"onboarding-stages"}>
        <span className={`stage ${index === 0 ? "active" : "done"}`}>
            <Icon>{index === 0 ? "adjust" : "check-circle-outline"}</Icon>
            <Text size={14} align={"center"}>{__("onboarding.stages.first")}</Text>
        </span>
        <span className={`line ${index === 1 ? "active" : index > 1 ? "done" : ""}`} />
        <span className={`stage ${index === 1 ? "active" : index > 1 ? "done" : ""}`}>
            <Text size={14} align={"center"}>{__("onboarding.stages.second")}</Text>
            {index >= 1 && <Icon>{index === 1 ? "adjust" : "check-circle-outline"}</Icon>}
        </span>
        <span className={`line ${index === 2 ? "active" : index > 1 ? "done" : ""}`} />
        <span className={`stage ${index === 2 ? "active" : index > 1 ? "done" : ""}`}>
            <Text size={14} align={"center"}>{__("onboarding.stages.third")}</Text>
            {index >= 2 && <Icon>{index === 2 ? "adjust" : "check-circle-outline"}</Icon>}
        </span>
    </div>;
};

OnboardingStages.propTypes = {
    index: number.isRequired
};

export default OnboardingStages;